import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const TestimonialsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="testimonials-page" className="bg-[#FAF5EC] min-h-screen text-kiki-ink warm-spotlight">
      <header className="border-b border-kiki-line bg-[#FAF5EC]/85 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center">
          <Link data-testid="testimonials-back-link" to="/" className="flex items-center gap-2.5 text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300 font-outfit">
            <ArrowLeft className="w-4 h-4" />
            <img src="/logo.png" alt="Kiki Services" className="w-8 h-8 rounded-full object-cover border border-kiki-line" />
            <span className="font-display text-xl text-kiki-ink">Kiki<span className="italic text-kiki-gold">Services</span></span>
          </Link>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <Reveal>
          <span className="mx-auto w-16 h-16 rounded-full bg-kiki-surface border border-kiki-line flex items-center justify-center text-kiki-gold">
            <Quote className="w-7 h-7" />
          </span>
        </Reveal>
        <Reveal delay={0.1}><div className="mt-6"><Eyebrow>Client stories</Eyebrow></div></Reveal>
        <Reveal delay={0.2}>
          <h1 className="font-display text-4xl sm:text-6xl font-medium tracking-tight text-kiki-ink mt-3 leading-[1.05]">
            Testimonials,<br /><span className="italic text-kiki-gold">coming soon</span>
          </h1>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-6 text-lg text-kiki-muted font-light leading-relaxed max-w-xl mx-auto">
            We are a young practice building our first client stories. This page will
            soon hold the words of the founders and teams we work with — perhaps yours.
          </p>
        </Reveal>
        <Reveal delay={0.4}>
          <Link
            data-testid="testimonials-book-btn"
            to="/book"
            className="mt-8 inline-flex items-center gap-2 bg-kiki-ink hover:bg-kiki-gold text-[#FAF5EC] font-outfit font-semibold rounded-full px-8 py-4 transition-colors duration-300"
          >
            Become our first story <ArrowUpRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </div>
  );
};

export default TestimonialsPage;
